// plugins/third-party-scripts.client.ts
export default defineNuxtPlugin(() => {
    // --- 1. CONFIGURACIÓN DE IDS ---
    const PIXEL_ID = '224527781081033';
    const CLARITY_ID = 'qci2mplxma';
    const SECONDS_TO_WAIT = 5; // Segundos de inactividad antes de cargar
   
    // --- 2. PREPARAR LAS "COLAS DE EVENTOS" ---
   
    // Para Facebook Pixel
    const f: any = window;
    if (!f.fbq) {
     const n = f.fbq = function(...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
     };
     if (!f._fbq) f._fbq = n;
     n.push = n;
     n.loaded = !0;
     n.version = '2.0';
     n.queue = [];
    }
   
    // --- 3. LÓGICA DE CARGA UNIFICADA ---
    let scriptsLoaded = false;
    const loadThirdPartyScripts = () => {
     if (scriptsLoaded) return;
     scriptsLoaded = true;
   
     // 🚀 Cargar Microsoft Clarity
     (function(c,l,a,r,i,t,y){
       c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
       t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
       y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
     })(window, document, "clarity", "script", CLARITY_ID);
     
     // 🚀 Cargar Facebook Pixel
     const fbScript = document.createElement('script');
     fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
     fbScript.async = true;
     fbScript.onload = () => {
      fbq('init', PIXEL_ID);
      fbq('track', 'PageView');
     };
     document.head.appendChild(fbScript);
   
     // Limpiar los listeners
     ['scroll', 'mousemove', 'touchstart'].forEach(event => 
      window.removeEventListener(event, loadThirdPartyScripts)
     );
    };
   
    // --- 4. DISPARADORES DE CARGA ---
    setTimeout(loadThirdPartyScripts, SECONDS_TO_WAIT * 1000);
    ['scroll', 'mousemove', 'touchstart'].forEach(event => 
     window.addEventListener(event, loadThirdPartyScripts, { once: true, passive: true })
    );
   });